module.exports = {"Description":"IE","RedundantCharacters":"","ValidationRegex":"^[AaC-Fc-fHhKkNnPpRrTtV-Yv-y]\\d[0-9Ww][ -]?[0-9AaC-Fc-fHhKkNnPpRrTtV-Yv-y]{4}$","ValidationRegex.DOC":"https://www.eircode.ie/docs/default-source/Common/prepareyourbusinessforeircode-edition3published.pdf?sfvrsn=2","TestData":{"Valid":["D6W1234","A23 0984","D00-AV92","y631fhk","a00 0000","d44-n4x4","A65F4E2"],"Invalid":["D6Z1234","y63  1fhk"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/IE.json
// module id = 4461
// module chunks = 11